import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { CompanyClientResponse } from "../types/api.types";
import Dropdown from "./Dropdown";

interface IChangeCompany {
  selectedCompany?: CompanyClientResponse | null;
  showModal: boolean;
  setShowModal: (newShowModal: boolean) => void;
  companyOptions: CompanyClientResponse[];
  onCompanyChange?: (clientId: string) => void;
  onSubmitProp: (data: CompanyFormData) => void;
}

interface CompanyFormData {
  company: string;
}

const ChangeCompanyModal: React.FC<IChangeCompany> = ({
  selectedCompany,
  setShowModal,
  showModal,
  companyOptions,
  onCompanyChange,
  onSubmitProp,
}) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm<CompanyFormData>({
    defaultValues: {
      company: companyOptions[0]?.clientID || "",
    },
  });

  const onSubmit = (data: CompanyFormData) => {
    onSubmitProp(data);
    if (onCompanyChange) {
      onCompanyChange(data.company);
    }
    setShowModal(false);
  };

  useEffect(() => {
    if (selectedCompany) {
      setValue("company", selectedCompany.clientID);
    }
  }, [selectedCompany]);

  return (
    <Dialog
      open={showModal}
      onClose={() => setShowModal(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      fullWidth
      maxWidth="xs"
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle id="modal-modal-title">Cambiar empresa</DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          <Controller
            name="company"
            control={control}
            rules={{ required: "La empresa es requerida" }}
            render={({ field }) => (
              <Dropdown
                label="Empresa"
                field={field}
                searchable
                searchPlaceholder="Buscar empresa..."
                options={companyOptions?.map((company) => ({
                  id: company.clientID,
                  label: company.comercialName,
                  cuit: company.cuit,
                  comercialName: company.comercialName,
                  legalName: company.legalName,
                }))}
                error={errors.company?.message}
                renderOption={(option: any) => (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                      overflow: "hidden",
                    }}
                  >
                    {/* CUIT */}
                    <Box
                      sx={{
                        width: 120,
                        textAlign: "right",
                        pr: 1,
                        whiteSpace: "nowrap",
                        fontFamily: "monospace",
                        fontWeight: 500,
                      }}
                    >
                      {option.cuit}
                    </Box>

                    <Box sx={{ px: 1 }}>-</Box>

                    {/* Nombre comercial */}
                    <Box
                      sx={{
                        width: 220,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        pr: 1,
                      }}
                    >
                      {option.comercialName}
                    </Box>

                    <Box sx={{ px: 1 }}>-</Box>

                    {/* Razón social */}
                    <Box
                      sx={{
                        flex: 1,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {option.legalName}
                    </Box>
                  </Box>
                )}
              />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowModal(false)}>Cancelar</Button>
          <Button type="submit" variant="contained" color="primary">
            Cambiar
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default ChangeCompanyModal;
